export default {
  siteUrl: 'https://nottinghamforest.co.uk',

  officialLinks: [
    {name: 'Official Website', slug: 'https://nottinghamforest.co.uk', newTab: false},
    {name: 'Online Store', slug: 'https://shop.nottinghamforest.co.uk/', newTab: false},
    {name: 'Ticketing', slug: 'https://www.eticketing.co.uk/nottinghamforest/', newTab: false},
    {name: 'Community Trust', slug: 'https://nottinghamforestcommunitytrust.co.uk/', newTab: false}
  ]
}